export default (rule, json) => {
  let res = {
    success: true,
    message: "",
    data: json,
  };

  for (let keyName in rule) {
    if (rule[keyName].required && (json[keyName] === "" || json[keyName] == null)) {
      res.success = false;
      res.message = rule[keyName].required;

      break;
    }

    // regExp
  }

  return res
}